var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"id":"Loading","opacity":0.3,"value":_vm.is_loading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}}),_c('p',{staticClass:"mt-2 medium"},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }